import { memoizedFetchSiteUserPersonalization } from '@jira/platform__services-personalization/src/services/site-user/index.tsx';

export const jiraUserIsActiveAfterDate = async (
	cloudId: string,
	userId: string,
	fromDate: Date,
): Promise<boolean> => {
	const userTraits = await memoizedFetchSiteUserPersonalization({ cloudId, userId });
	const firstActiveTrait = userTraits.find((trait) => trait.name === 'jira_first_active');

	if (!firstActiveTrait?.value) {
		// Trait absent — cannot verify post-experiment eligibility, exclude.
		return false;
	}

	return new Date(firstActiveTrait.value.toString()) >= fromDate;
};
